import { gql } from '@apollo/client';

export const GET_ACCESS_CODES_BY_ORDER_ID = gql`
    query GetAccessCodesByOrderId($orderId: Long!) {
        getAccessCodesByOrderId(orderId: $orderId) {
            id
            addressId
            codeType
            accessCode
            status
            latitude
            longitude
            validFeedbackCount
            invalidFeedbackCount
            lastAccessCodeUpdatedAt
            accessCodeCreatedAt
            accessCodeUpdatedAt
            currentUserFeedback
            currentDriverCreatedAt
            currentDriverUpdatedAt
        }
    }
`;

export interface AccessCodeWithStatsType {
    id: number;
    addressId: number;
    codeType: string;
    accessCode: string | null;
    status: number | null;
    latitude: number | null;
    longitude: number | null;
    validFeedbackCount: number;
    invalidFeedbackCount: number;
    lastAccessCodeUpdatedAt: number | null;
    accessCodeCreatedAt: number | null;
    accessCodeUpdatedAt: number | null;
    currentUserFeedback: number;
    currentDriverCreatedAt: number | null;
    currentDriverUpdatedAt: number | null;
}

export interface GetAccessCodesByOrderIdResponse {
    getAccessCodesByOrderId: AccessCodeWithStatsType[];
}

export interface GetAccessCodesByOrderIdVariables {
    orderId: number;
}
